import { render, staticRenderFns } from "./RiskDashboardPDF.vue?vue&type=template&id=7ff4bbf2"
import script from "./RiskDashboardPDF.vue?vue&type=script&lang=js"
export * from "./RiskDashboardPDF.vue?vue&type=script&lang=js"
import style0 from "./RiskDashboardPDF.vue?vue&type=style&index=0&id=7ff4bbf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports